export function TickMarkIcon() {
  return (
    <svg height="13" viewBox="-5 -4 16 16" width="13" xmlns="http://www.w3.org/2000/svg">
      <path d="M 12 4 L 6.5 9.5 L 4 7 L 5 6 L 6.5 7.5 L 11 3 Z" fill="white" transform="scale(2) translate(-4, -4)"/>
    </svg>
  );
}